export * from "./apiClient";
export * from "./formatters";
export * from "./iconResolver";
export * from "./logger";
export * from "./sentry";
export * from "./themes";
export * from "./validators";
export * from "./rsoAuth";
export * from "./riotBarHelper";
export * from "./localizationHelper";
// You may add additional domains to this list if you so choose
var ALLOWED_DOMAINS = [
    "www.sandbox.paypal.com",
    "www.paypal.com",
    "apitest.smart2pay.com",
    "globalapi.smart2pay.com"
];
/**
 * Determines if the current URL is actually from one of the items in array.
 * @param {String} url
 */
export function isExternalBrowserURL(url) {
    try {
        var uri = new URL(url);
        return uri.protocol === "https:" && ALLOWED_DOMAINS.includes(uri.hostname);
    }
    catch (e) {
        return false;
    }
}
//# sourceMappingURL=index.js.map